import { ProtectedServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import { fromDto as reservationFromDto } from '../../../models/adapters/ReservationAdapter';
import { toDto as specialHourToDto } from '../../../models/adapters/SpecialHourAdapter';
import { modifySpecialHour, ModifySpecialHourActionType, specialHourModified, specialHourModifyFailed } from '../../actions/setting/modifySpecialHour';
import getAuthenticationToken from '../getAuthenticationToken';
import getProtectedResponse from '../getProtectedResponse';

function* modifySpecialHourSaga({ payload }: ModifySpecialHourActionType) {
  const { specialHourUuid, specialHour, placeUuid } = payload;
  const token = yield getAuthenticationToken();
  const specialHourDto = specialHourToDto(specialHour);
  const timestamp = moment();
  const response = yield getProtectedResponse(ProtectedServerPlaceEvent.modifySpecialHour, token, {
    specialHourDto,
    placeUuid,
  });
  if (!response.error) {
    const { affectedReservations: affectedReservationDtos } = response;
    const affectedReservations = (affectedReservationDtos || []).map(reservationFromDto);
    yield put(
      specialHourModified({
        specialHourUuid,
        specialHour,
        placeUuid,
        timestamp,
        affectedReservations,
      })
    );
  } else {
    yield put(specialHourModifyFailed({ placeUuid, specialHourUuid, timestamp }));
  }
}

export default function* watchModifySpecialHourSaga() {
  yield takeEvery(modifySpecialHour, modifySpecialHourSaga);
}
